import { render, staticRenderFns } from "./purchasesOrderTakeIn.vue?vue&type=template&id=298722ea&scoped=true&"
import script from "./purchasesOrderTakeIn.vue?vue&type=script&lang=js&"
export * from "./purchasesOrderTakeIn.vue?vue&type=script&lang=js&"
import style0 from "./purchasesOrderTakeIn.vue?vue&type=style&index=0&id=298722ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298722ea",
  null
  
)

component.options.__file = "purchasesOrderTakeIn.vue"
export default component.exports